import { OUVERT } from '@/configuration/compta/exerciceComptable';

export default function genererExerciceComptable() {
  return {
    code: null,
    societeId: null,
    etat: OUVERT,
    dateDebut: null,
    dateFin: null,
  };
}
